import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const MedalStar = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 24 25"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g>
        <g>
          <path
            d="M19 9.40771C19 10.8577 18.57 12.1877 17.83 13.2977C16.75 14.8977 15.04 16.0277 13.05 16.3177C12.71 16.3777 12.36 16.4077 12 16.4077C11.64 16.4077 11.29 16.3777 10.95 16.3177C8.96 16.0277 7.25 14.8977 6.17 13.2977C5.43 12.1877 5 10.8577 5 9.40771C5 5.53771 8.13 2.40771 12 2.40771C15.87 2.40771 19 5.53771 19 9.40771Z"
            stroke={stroke}
            strokeWidth=" 1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.2491 18.8776L19.5991 19.2676C19.2291 19.3576 18.9391 19.6376 18.8591 20.0076L18.5091 21.4776C18.3191 22.2776 17.2991 22.5176 16.7691 21.8876L11.9991 16.4076L7.2291 21.8976C6.6991 22.5276 5.6791 22.2876 5.4891 21.4876L5.1391 20.0176C5.0491 19.6476 4.7591 19.3576 4.3991 19.2776L2.7491 18.8876C1.9891 18.7076 1.7191 17.7576 2.2691 17.2076L6.1691 13.3076C7.2491 14.9076 8.9591 16.0376 10.9491 16.3276C11.2891 16.3876 11.6391 16.4176 11.9991 16.4176C12.3591 16.4176 12.7091 16.3876 13.0491 16.3276C15.0391 16.0376 16.7491 14.9076 17.8291 13.3076L21.7291 17.2076C22.2791 17.7476 22.0091 18.6976 21.2491 18.8776Z"
            stroke={stroke}
            strokeWidth=" 1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.58 6.38771L13.17 7.56771C13.25 7.72771 13.46 7.88771 13.65 7.91771L14.72 8.09771C15.4 8.20771 15.56 8.70771 15.07 9.19771L14.24 10.0277C14.1 10.1677 14.02 10.4377 14.07 10.6377L14.31 11.6677C14.5 12.4777 14.07 12.7977 13.35 12.3677L12.35 11.7777C12.17 11.6677 11.87 11.6677 11.69 11.7777L10.69 12.3677C9.96997 12.7877 9.53997 12.4777 9.72997 11.6677L9.96997 10.6377C10.01 10.4477 9.93997 10.1677 9.79997 10.0277L8.96997 9.19771C8.47997 8.70771 8.63997 8.21771 9.31997 8.09771L10.39 7.91771C10.57 7.88771 10.78 7.72771 10.86 7.56771L11.45 6.38771C11.74 5.74771 12.26 5.74771 12.58 6.38771Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

MedalStar.displayName = 'MedalStar';
